/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-empty-function */
import React, { PureComponent } from 'react';
import SpecialityProductRates from "../Pricing/SpecialityProducts/index.js";
import Button from '../../components/Button.js';
import Tiles from '../../components/Tiles/index.js';
import MessageCard from '../../components/Cards/MessageCard.js';
import Text from '../../components/Text.js';
import Modal from '../../components/Modals/Modal.js';
import ClassesDivisions from '../ClassesDivisions/index.js';
import AccountHistory from '../AccountHistory/index.js';
import PlanDesign from '../PlanDesign/Container.js';
import CommissionsForm from '../Commissions/index.js';
import MasterApplication from '../MasterApplication/index.js';
import Pricing from '../Pricing/index.js';
import AssignPlans from '../AssignPlans/index.js';
import MetaBlock from '../../components/MetaBlock.js';
import MetaModal from '../../components/Modals/MetaModal.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class Quote extends PureComponent {
  state = {
    showSendForReviewDialog: false,
    showConvertQuote: false,
    showQuoteMetaModal: false
  };
  _getTiles = () => {
    const isPrivateLabelAdvisor = Boolean(this.props.advisorMeta.privateLabelID);
    if (isPrivateLabelAdvisor) {
      return [{
        title: i18n.t(tokens.titles.classesAndDivisions),
        description: 'Manage the Classes and Divisions for the Quote.',
        step: 1,
        onClick: () => this.props.setSelectedSection('classes-divisions'),
        testid: 'classes-divisions-tile',
        completed: Number(this.props.quote.meta.state) >= 1
      }, {
        title: i18n.t(tokens.titles.planDesign),
        description: 'View and customize plan designs for each class.',
        step: 2,
        onClick: () => this.props.setSelectedSection('plan-design'),
        testid: 'plan-design-tile',
        completed: Number(this.props.quote.meta.state) >= 1
      }, {
        title: i18n.t(tokens.titles.specialityProductRates),
        description: i18n.t(tokens.labels.specialityProductRatesTileDesc),
        step: 3,
        onClick: () => this.props.setSelectedSection('speciality-product-rates'),
        testid: 'speciality-product-rates-tile',
        disabled: Number(this.props.quote.meta.state) < 1,
        completed: Number(this.props.quote.meta.state) >= 4
      }, {
        title: 'Request Approval',
        description: 'Complete the Master Applicant and send to Signing Authority for approval.',
        step: 4,
        onClick: () => this.props.setSelectedSection('request-approval'),
        testid: 'finish-setup-tile',
        disabled: Number(this.props.quote.meta.state) < 4,
        completed: Number(this.props.quote.meta.state) >= 5,
        tooltip: {
          tip: "Please complete and submit the Plan Designs before continuing with the quote process.",
          position: 'right'
        }
      }];
    }
    const tiles = [{
      title: i18n.t(tokens.titles.classesAndDivisions),
      description: i18n.t(tokens.labels.advisor.manageClassesAndDivisions),
      step: 1,
      onClick: () => this.props.setSelectedSection('classes-divisions'),
      testid: 'classes-divisions-tile',
      completed: Number(this.props.quote.meta.state) >= 1
    }, {
      title: i18n.t(tokens.titles.accountHistory),
      description: i18n.t(tokens.labels.advisor.provideDocuments),
      step: 2,
      onClick: () => this.props.setSelectedSection('account-history'),
      testid: 'account-history-tile',
      completed: Number(this.props.quote.meta.state) >= 1
    }, {
      title: i18n.t(tokens.titles.planDesign),
      description: i18n.t(tokens.labels.advisor.viewCustomizePlanDesigns),
      step: 3,
      onClick: () => this.props.setSelectedSection('plan-design'),
      testid: 'plan-design-tile',
      completed: Number(this.props.quote.meta.state) >= 1
    }, {
      title: i18n.t(tokens.titles.commissions),
      description: i18n.t(tokens.labels.advisor.viewSetCommissionsForAccount),
      step: 4,
      tooltip: {
        tip: i18n.t(tokens.labels.advisor.completeSubmitPlanDesigns),
        position: 'right'
      },
      disabled: Number(this.props.quote.meta.state) < 1,
      onClick: () => this.props.setSelectedSection('commissions'),
      testid: 'commissions-tile',
      completed: Number(this.props.quote.meta.state) >= 2
    }, {
      title: i18n.t(tokens.titles.masterApplication),
      description: i18n.t(tokens.labels.advisor.completeSubmitMasterApplication),
      step: 5,
      tooltip: {
        tip: i18n.t(tokens.labels.advisor.completeSubmitCommissions),
        position: 'left'
      },
      disabled: Number(this.props.quote.meta.state) < 2,
      onClick: () => this.props.setSelectedSection('master-application'),
      testid: 'master-application-tile',
      completed: Number(this.props.quote.meta.state) >= 3
    }];
    if (this.props.isMasterSite) {
      tiles.push({
        title: i18n.t(tokens.titles.specialityProductRates),
        description: i18n.t(tokens.labels.specialityProductRatesTileDesc),
        step: 6,
        onClick: () => this.props.setSelectedSection('speciality-product-rates'),
        testid: 'speciality-product-rates-tile',
        disabled: Number(this.props.quote.meta.state) < 3,
        completed: Number(this.props.quote.meta.state) > 3
      });
      tiles.push({
        title: i18n.t(tokens.titles.pricing),
        description: i18n.t(tokens.labels.advisor.setPricingForPlanDesigns),
        step: 7,
        tooltip: {
          tip: i18n.t(tokens.labels.advisor.pleaseCompleteSubmitMasterApplication),
          position: 'right'
        },
        onClick: () => this.props.setSelectedSection('pricing'),
        testid: 'pricing-tile',
        disabled: Number(this.props.quote.meta.state) < 4,
        completed: Number(this.props.quote.meta.state) > 4
      });
      tiles.push({
        title: i18n.t(tokens.titles.assignPlans),
        description: 'Assign the final plan design for each class.',
        step: 8,
        tooltip: {
          tip: Number(this.props.quote.meta.state) <= 5 ? "Once pricing has been set you will be able to assign your plan designs to your classes." : "You have already assigned the plan designs for this quote.",
          position: 'left',
          alwaysShow: true
        },
        disabled: Number(this.props.quote.meta.state) < 5,
        onClick: Number(this.props.quote.meta.state) <= 5 ? () => this.props.setSelectedSection('assign-plans') : () => {},
        testid: 'advisor-assign-plans',
        completed: Number(this.props.quote.meta.state) > 5
      });
      tiles.push({
        title: 'Request Approval',
        description: 'Review and send quote to Signing Authority for review.',
        tooltip: {
          tip: Number(this.props.quote.meta.state) <= 6 ? "Please complete and submit the Assign Plans before continuing with the quote process." : "You have already submitted the quote for approval.",
          position: 'right',
          alwaysShow: true
        },
        disabled: Number(this.props.quote.meta.state) < 6,
        step: 9,
        onClick: () => this.props.setSelectedSection('request-approval'),
        completed: Number(this.props.quote.meta.state) >= 7,
        testid: 'finish-setup-tile'
      });
    } else {
      tiles.push({
        title: i18n.t(tokens.titles.sendForUnderwriting),
        description: i18n.t(tokens.labels.advisor.submitAccountUnderwritingPricing),
        step: 6,
        tooltip: {
          tip: Number(this.props.quote.meta.state) <= 3 ? i18n.t(tokens.labels.advisor.pleaseCompleteSubmitMasterApplication) : i18n.t(tokens.labels.advisor.alreadySentQuoteUnderwriting),
          position: 'right',
          alwaysShow: true
        },
        disabled: Number(this.props.quote.meta.state) < 3,
        onClick: Number(this.props.quote.meta.state) <= 3 ? this._toggleSendForReviewDialog : () => {},
        testid: 'submit-review-tile',
        completed: Number(this.props.quote.meta.state) >= 4
      });
      tiles.push({
        title: i18n.t(tokens.titles.assignPlans),
        description: i18n.t(tokens.labels.advisor.assignFinalPlanDesigns),
        step: 7,
        tooltip: {
          tip: Number(this.props.quote.meta.state) <= 5 ? i18n.t(tokens.labels.advisor.assignPlansNote) : i18n.t(tokens.labels.advisor.alreadyAssignedPlanDesigns),
          position: 'left',
          alwaysShow: true
        },
        disabled: Number(this.props.quote.meta.state) < 5,
        onClick: Number(this.props.quote.meta.state) <= 5 ? () => this.props.setSelectedSection('assign-plans') : () => {},
        testid: 'advisor-assign-plans',
        completed: Number(this.props.quote.meta.state) >= 6
      });
      tiles.push({
        title: i18n.t(tokens.titles.requestApproval),
        description: i18n.t(tokens.labels.advisor.reviewSendQuote),
        tooltip: {
          tip: Number(this.props.quote.meta.state) <= 6 ? i18n.t(tokens.labels.advisor.completeSubmitAssignPlans) : i18n.t(tokens.labels.advisor.alreadySubmittedQuoteApproval),
          position: 'right',
          alwaysShow: Number(this.props.quote.meta.state) !== 7
        },
        disabled: Number(this.props.quote.meta.state) < 6,
        step: 9,
        onClick: Number(this.props.quote.meta.state) <= 6 ? () => this.props.setSelectedSection('request-approval') : () => {},
        testid: 'finish-setup-tile',
        completed: Number(this.props.quote.meta.state) >= 7
      });
    }
    return tiles;
  };
  _toggleMetaModal = () => {
    this.setState({
      showQuoteMetaModal: !this.state.showQuoteMetaModal
    });
  };
  _toggleSendForReviewDialog = () => {
    this.setState({
      showSendForReviewDialog: !this.state.showSendForReviewDialog
    });
  };
  _toggleConvertQuote = () => {
    if (!this.props.advisorMeta.privateLabelID && !this.props.isMasterSite) {
      return null;
    }
    this.setState({
      showConvertQuote: !this.state.showConvertQuote
    });
    return true;
  };
  _convertQuoteToSold = async () => {
    if (!this.props.advisorMeta.privateLabelID && !this.props.isMasterSite) {
      return null;
    }
    const success = await this.props.convertQuote();
    if (success) {
      this._toggleConvertQuote();
    }
    return true;
  };
  _requestReview = () => {
    this._toggleSendForReviewDialog();
    this.props.sendReviewRequest(null);
  };
  render() {
    const {
      quote,
      whitelabel
    } = this.props;
    const tiles = this._getTiles();

    // if it's a private label advisor, they must be able to do all steps themselves from the advisor site
    const isPrivateLabelAdvisor = Boolean(this.props.advisorMeta.privateLabelID);
    return /*#__PURE__*/React.createElement(React.Fragment, null, !this.props.selectedSection && /*#__PURE__*/React.createElement(React.Fragment, null, !isPrivateLabelAdvisor && quote.meta.state >= 2 && /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      customStyle: {
        display: 'block',
        marginLeft: 'auto',
        height: 45,
        textTransform: "capitalize",
        fontSize: 15
      },
      onClick: this.props.downloadCarrierPackage
    }, i18n.t(tokens.buttons.downloadCarrierPackage)), this.props.quote.meta.state === 4 && !this.props.isMasterSite && !isPrivateLabelAdvisor && /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.underwritingQuote),
      subtitle: i18n.t(tokens.labels.quotes.underwritingMessage)
    }), this.props.quote.meta.state === 6 && /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.buttons.sendForApproval),
      subtitle: i18n.t(tokens.labels.quotes.requestApprovalMessage)
    }), this.props.quote.meta.state === 7 && /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.quotes.signingAuthorityApprovalPending),
      subtitle: isPrivateLabelAdvisor ? "Once the Signing Authority signs and submits the Master Application, the quote will be converted into an Account. This will allow you to proceed with the account setup." : i18n.t(tokens.labels.quotes.sentToSimplyBenefits)
    }), !isPrivateLabelAdvisor && !this.props.isMasterSite && this.props.quote.meta.state === 8 && /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.quotes.simplyBenefitsApprovalPending),
      subtitle: i18n.t(tokens.labels.quotes.finalReviewStage)
    }), (this.props.isMasterSite || isPrivateLabelAdvisor) && this.props.currentAccountMeta.state === 8 && this.props.currentAccountMeta.status === 'In Progress' && /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.quotes.quoteSold),
      subtitle: i18n.t(tokens.labels.quotes.signingAuthorityAccepted),
      btn: true,
      btnName: i18n.t(tokens.buttons.convertQuote),
      btnOnClick: this._toggleConvertQuote
    }), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      margin: "10px"
    }, i18n.t(tokens.labels.quotes.quoteSetup)), /*#__PURE__*/React.createElement(Tiles, {
      tiles: tiles,
      stepped: true
    }), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      margin: "20px 10px 15px 10px"
    }, i18n.t(tokens.labels.quotes.companyDetails)), /*#__PURE__*/React.createElement(MetaBlock, {
      data: quote,
      showModal: this._toggleMetaModal
    }), this.state.showQuoteMetaModal && /*#__PURE__*/React.createElement(MetaModal, {
      hideModal: this._toggleMetaModal,
      showModal: this.state.showQuoteMetaModal,
      loader: this.props.loader,
      edit: this.props.editQuote,
      isMasterSite: this.props.isMasterSite,
      isEdit: true,
      data: quote,
      whitelabel: this.props.whitelabel,
      advisorMeta: this.props.advisorMeta
    })), this.props.selectedSection === 'classes-divisions' && /*#__PURE__*/React.createElement(ClassesDivisions, {
      currentAccountMeta: this.props.currentAccountMeta,
      setState: this.props.setState,
      editClass: this.props.editClass,
      addClass: this.props.addClass,
      removeClass: this.props.removeClass,
      addDivision: this.props.addDivision,
      editDivision: this.props.editDivision,
      removeDivision: this.props.removeDivision,
      validateBankingDetails: this.props.validateBankingDetails,
      bankingDetailsVerifying: this.props.bankingDetailsVerifying,
      classData: quote.classes,
      divisions: quote.divisions,
      isQuote: true,
      isMasterSite: this.props.isMasterSite,
      step: quote.meta.state,
      loader: this.props.loader,
      whitelabel: whitelabel,
      isPrivateLabelAdvisor: isPrivateLabelAdvisor,
      language: this.props.language || "en"
    }), this.props.selectedSection === 'account-history' && /*#__PURE__*/React.createElement(AccountHistory, {
      uploadAccountHistory: this.props.uploadAccountHistory,
      isMasterSite: this.props.isMasterSite,
      accountID: this.props.currentAccountMeta.accountID,
      isQuote: true,
      loader: this.props.loader,
      whitelabel: whitelabel,
      isPrivateLabelAdvisor: isPrivateLabelAdvisor
    }), this.props.selectedSection === 'plan-design' && /*#__PURE__*/React.createElement(PlanDesign, {
      setSelectedSection: this.props.setSelectedSection,
      quote: quote,
      isMasterSite: this.props.isMasterSite,
      isQuote: true,
      step: quote.meta.state,
      currentAccountMeta: this.props.currentAccountMeta,
      classData: quote.classes,
      designs: quote.planDesigns,
      specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
      modularBlueprints: quote.modularBlueprints,
      submitPlanDesigns: this.props.submitPlanDesigns,
      submitModuleBlueprint: this.props.submitModuleBlueprint,
      savePlanType: this.props.savePlanType,
      createPlanDesign: this.props.createPlanDesign,
      createPlanDesignFromUpload: this.props.createPlanDesignFromUpload,
      savePlanDesign: this.props.savePlanDesign,
      clonePlanDesign: this.props.clonePlanDesign,
      savePlanDesignBenefitInitData: this.props.savePlanDesignBenefitInitData,
      savePlanDesignField: this.props.savePlanDesignField,
      getPlanDesignRevisions: this.props.getPlanDesignRevisions,
      getSinglePlanDesignRevision: this.props.getSinglePlanDesignRevision,
      revertToRevision: this.props.revertToRevision,
      saveModularBlueprint: this.props.saveModularBlueprint,
      saveModularBenefitInitData: this.props.saveModularBenefitInitData,
      saveModularField: this.props.saveModularField,
      loader: this.props.loader,
      whitelabel: whitelabel,
      language: this.props.advisorMeta.language || 'en',
      isPrivateLabelAdvisor: isPrivateLabelAdvisor
    }), this.props.selectedSection === 'commissions' && /*#__PURE__*/React.createElement(CommissionsForm, {
      isMasterSite: this.props.isMasterSite,
      currentAccountMeta: this.props.currentAccountMeta,
      isQuote: true,
      setSelectedSection: this.props.setSelectedSection,
      submitCommissions: this.props.submitCommissions,
      saveCommissions: this.props.saveCommissions,
      getCommissions: this.props.getCommissions,
      loader: this.props.loader,
      whitelabel: whitelabel,
      isPrivateLabelAdvisor: isPrivateLabelAdvisor
    }), this.props.selectedSection === 'master-application' && /*#__PURE__*/React.createElement(MasterApplication, {
      setSelectedSection: this.props.setSelectedSection,
      advisorMeta: this.props.advisorMeta,
      isMasterSite: this.props.isMasterSite,
      isQuote: true,
      quote: quote,
      currentAccountMeta: this.props.currentAccountMeta,
      isReadOnly: quote.meta.status !== 'In Progress' || quote.meta.state >= 7,
      getMasterApplicationData: this.props.getMasterApplicationData,
      updateMasterApp: this.props.updateMasterApp,
      completeMasterApp: this.props.completeMasterApp,
      loader: this.props.loader,
      displayError: this.props.displayError,
      whitelabel: whitelabel,
      isPrivateLabelAdvisor: isPrivateLabelAdvisor
    }), this.props.selectedSection === 'request-approval' && /*#__PURE__*/React.createElement(MasterApplication, {
      setSelectedSection: this.props.setSelectedSection,
      advisorMeta: this.props.advisorMeta,
      isMasterSite: this.props.isMasterSite,
      isQuote: true,
      quote: quote,
      currentAccountMeta: this.props.currentAccountMeta,
      getMasterApplicationData: this.props.getMasterApplicationData,
      updateMasterApp: this.props.updateMasterApp,
      completeMasterApp: this.props.completeMasterApp,
      sendRequestApprovalLink: this.props.sendMasterAppLink,
      loader: this.props.loader,
      displayError: this.props.displayError,
      whitelabel: whitelabel,
      isPrivateLabelAdvisor: isPrivateLabelAdvisor
    }), this.props.selectedSection === 'pricing' && this.props.isMasterSite && /*#__PURE__*/React.createElement(Pricing, {
      classData: quote.classes,
      designs: quote.planDesigns,
      commissions: quote.commissions,
      setSelectedSection: this.props.setSelectedSection,
      advisorMeta: this.props.advisorMeta,
      isMasterSite: this.props.isMasterSite,
      quote: quote,
      isQuote: true,
      currentAccountMeta: this.props.currentAccountMeta,
      submitPricing: this.props.submitPricing,
      savePricingInput: this.props.savePricingInput,
      savePricing: this.props.savePricing,
      saveTelusDrugPlanID: this.props.saveTelusDrugPlanID,
      getPricingRevisions: this.props.getPricingRevisions,
      getSinglePricingRevision: this.props.getSinglePricingRevision,
      saveCoverages: this.props.saveCoverages,
      loader: this.props.loader,
      whitelabel: whitelabel,
      isPrivateLabelAdvisor: isPrivateLabelAdvisor
    }), this.props.selectedSection === 'assign-plans' && /*#__PURE__*/React.createElement(AssignPlans, {
      classData: quote.classes,
      designs: quote.planDesigns,
      setSelectedSection: this.props.setSelectedSection,
      advisorMeta: this.props.advisorMeta,
      isMasterSite: this.props.isMasterSite,
      quote: quote,
      isQuote: true,
      currentAccountMeta: this.props.currentAccountMeta,
      getPlanDesignPremiumSummaries: this.props.getPlanDesignPremiumSummaries,
      assignPlans: this.props.assignPlans,
      rejectPricing: this.props.rejectPricing,
      loader: this.props.loader,
      whitelabel: whitelabel,
      isPrivateLabelAdvisor: isPrivateLabelAdvisor
    }), this.props.selectedSection === 'speciality-product-rates' && /*#__PURE__*/React.createElement(SpecialityProductRates, {
      quote: quote,
      getSpecialityProductRates: this.props.getSpecialityProductRates,
      specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
      saveSpecialityProductRates: this.props.saveSpecialityProductRates,
      submitSpecialityProductRates: this.props.submitSpecialityProductRates,
      downloadRatesPdf: this.props.downloadSpecialityProductRatesPdf,
      isMasterSite: this.props.isMasterSite,
      currentAccountMeta: this.props.currentAccountMeta,
      loading: this.props.loading,
      whitelabel: whitelabel,
      step: quote.meta.state
    }), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showSendForReviewDialog,
      onClose: this._toggleSendForReviewDialog,
      title: i18n.t(tokens.titles.areYouSure),
      primaryButton: {
        label: i18n.t(tokens.buttons.requestReview),
        onClick: this._requestReview
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.quotes.requestReview))), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showConvertQuote,
      onClose: this._toggleConvertQuote,
      title: i18n.t(tokens.titles.areYouSure),
      primaryButton: {
        label: i18n.t(tokens.buttons.continue),
        onClick: this._convertQuoteToSold
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, "By clicking the button below, you will be finishing the Quoting process and converting the Quote to an account within the Simply Benefits system. From this point on you will be required to enter the Census data and set the account live.")));
  }
}
export default Quote;